import { SidebarItem } from '@backstage/core-components';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { usePermission } from '@backstage/plugin-permission-react';
import { chartSummaryReadPermission } from '@internal/plugin-dev-services-chart-summary-common';
import { IconComponent } from '@backstage/core-plugin-api';

export const ChartSummarySidebarItem = () => {
  const { loading, allowed } = usePermission({
    permission: chartSummaryReadPermission,
  });
  
  if (!loading && allowed) {
    return (
      <SidebarItem
        text="Chart Summary"
        to="chart-summary"
        icon={AssessmentIcon as IconComponent}
      />
    );
  }
  return null;
};
